'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ function () {

    var factory = {};

    /**
     * Given a list of trains, return an Object array of unique train maintainers.
     * Fields: code (train maintainer) and name (type to display).
     * @param trains
     * @returns {Array}
     */
    factory.getTrainMaintainerObjects = function (trains) {
        var collected = [];
        var maintainers = [];

        // run over trains
        trains.forEach(function(train) {
            var maintainer = train.maintainer;

            // check current list.
            if (collected.indexOf(maintainer) == -1) {
                // not yet found
                // -> push it on the collected array and create new TrainMaintainerObject.
                collected.push(maintainer);

                var maintainerData = factory.createTrainMaintainerObject(maintainer);
                maintainers.push(maintainerData);
            }
        });

        return maintainers;
    };


    /**
     * Creates a TrainMaintainerObject based on trainType.
     *
     * @param trainType
     * @returns created TrainTypeObject.
     */
    factory.createTrainMaintainerObject = function(trainType) {

        var typeData = {};
        typeData.code = trainType;
        typeData.name = trainType;

        return typeData;
    };

    /**
     * Given an array of TrainMaintainerObjects, return the TrainMaintainerObject containing the trainMaintainer string.
     * Returns null if it's not in the list.
     * @param trainMaintainerObjects
     * @param trainMaintainer
     * @returns TrainMaintainerObject if it exists.
     */
    factory.getTrainMaintainer = function(trainMaintainerObjects, trainMaintainer) {
        var trainMaintainerObject = null;

        trainMaintainerObjects.some(function(trainMaintainerData) {
            if (trainMaintainerData.code == trainMaintainer) {
                trainMaintainerObject = trainMaintainerData;
                return true;
            }

            return false;
        });

        return trainMaintainerObject;
    };


    /**
     * Given a Train, the function will return true/false, if the train maintainer is in the
     * trainMaintainerObjects list.
     * @param train
     * @param trainMaintainerObjects
     * @returns true/false
     */
    factory.filterTrainByMaintainersFilter = function (train, trainMaintainerObjects) {
        if (!util.isDefined(trainMaintainerObjects) || (trainMaintainerObjects.length == 0)) {
            return true;
        } else {
            var found = false;
            trainMaintainerObjects.some(function(trainMaintainerObject){
                if (trainMaintainerObject.code == train.maintainer) {
                    found = true;
                    return true;
                } else {
                    return false;
                }
            });

            return found;
        }
    };

    /**
     * Given a Train, the function will return true/false, if the train maintainer
     * is the same as the trainMaintainerObject.
     * @param train
     * @param trainMaintainerObject
     * @returns true/false
     */
    factory.filterTrainByMaintainerFilter = function (train, trainMaintainerObject) {
        if (!util.isDefined(trainMaintainerObject)) {
            return true;
        } else {
            return trainMaintainerObject.code == train.maintainer;
        }
    };


    return factory;

};
